import { getArrayOfValuesFromArray } from "lib/utils/array-utils";
import { DateTime } from "luxon";
import { FC } from "react";
import ReactApexChart from "react-apexcharts";
import "./custom.scss";

interface WorkingHoursChartProps {
  workingHours: WorkingHour[];
  width?: string | number;
  height?: string | number;
  className?: string;
}

const WorkingHoursChart: FC<WorkingHoursChartProps> = ({
  workingHours,
  width,
  height,
  className,
}) => {
  const series = [
    {
      name: "Working Hours",
      data: (workingHours ?? []).map(
        (item) =>
          DateTime.fromFormat(item.toTime, "hh:mm").diff(
            DateTime.fromFormat(item.fromTime, "hh:mm"),
            "hours"
          ).hours
      ),
    },
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      height: "100%",
      width: "100%",
      foreColor: "#999",
      redrawOnParentResize: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 3,
        borderRadiusApplication: "end",
      },
    },
    colors: ["#00C5A4", "#F3F2FC"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: getArrayOfValuesFromArray(workingHours, "day"),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          fontSize: "14px",
        },
      },
    },
    yaxis: {
      show: false,
      title: {
        text: "time (hours)",
      },
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    legend: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      enabled: true,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          w.globals.labels[dataPointIndex] +
          " - " +
          series[seriesIndex][dataPointIndex] +
          " hours" +
          "</span>" +
          "</div>"
        );
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={height ?? "100%"}
      width={width ?? "100%"}
      className={className}
    />
  );
};

export default WorkingHoursChart;
